import { ReactComponent as BootIcon } from "@/assets/method-icons/boot.svg";
import { ReactComponent as BootBetaIcon } from "@/assets/method-icons/boot_beta.svg";
import { ReactComponent as BenchIcon } from "@/assets/method-icons/bench.svg";
import { ReactComponent as BenchBetaIcon } from "@/assets/method-icons/bench_beta.svg";
import { ReactComponent as BenchPatchIcon } from "@/assets/method-icons/bench-patch.svg";
import { ReactComponent as BenchRemoteUnlockIcon } from "@/assets/method-icons/bench-remote-unlock.svg";
import { ReactComponent as ObdIcon } from "@/assets/method-icons/obd.svg";
import { ReactComponent as ObdBetaIcon } from "@/assets/method-icons/obd_beta.svg";
import { ReactComponent as ObdRemoteUnlockIcon } from "@/assets/method-icons/obd-remote-unlock.svg";
import { ReactComponent as ObdPatchBetaIcon } from "@/assets/method-icons/obd-patch-beta.svg";
import { ReactComponent as ObdPwdIcon } from "@/assets/method-icons/obd-pwd.svg";
import { ReactComponent as DatalogsIcon } from "@/assets/method-icons/datalogs.svg";
import { ReactComponent as DatalogsBetaIcon } from "@/assets/method-icons/datalogs_beta.svg";

// Every method label the scraper has ever seen belongs to one of these
// families (bench/boot/obd/datalogs), optionally suffixed with a variant
// (_beta, -patch, -pwd, -remote-unlock). Color is per-family so variants of
// the same base method stay visually grouped.
const FAMILY_COLORS = {
  bench: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  boot: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/40",
  obd: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  datalogs: "bg-amber-500/15 text-amber-300 border-amber-500/40",
};

function family(name) {
  const key = (name || "").toLowerCase();
  return ["bench", "boot", "obd", "datalogs"].find((f) => key.startsWith(f));
}

export function methodClass(name) {
  return FAMILY_COLORS[family(name)] || "bg-neutral-700/40 text-neutral-200 border-neutral-500/40";
}

const METHOD_ICONS = {
  boot: BootIcon,
  boot_beta: BootBetaIcon,
  bench: BenchIcon,
  bench_beta: BenchBetaIcon,
  "bench-patch": BenchPatchIcon,
  "bench-remote-unlock": BenchRemoteUnlockIcon,
  obd: ObdIcon,
  obd_beta: ObdBetaIcon,
  "obd-remote-unlock": ObdRemoteUnlockIcon,
  obd_patch_beta: ObdPatchBetaIcon,
  "obd-patch_beta": ObdPatchBetaIcon,
  "obd-pwd": ObdPwdIcon,
  datalogs: DatalogsIcon,
  datalogs_beta: DatalogsBetaIcon,
};

// Renders the method's icon when dedicated artwork exists; falls back to the
// text label otherwise (currently only obd-patch has no icon).
export default function MethodGlyph({ label, className = "w-7 h-7" }) {
  const Icon = METHOD_ICONS[(label || "").toLowerCase()];
  if (!Icon) {
    return <span>{label}</span>;
  }
  return <Icon className={className} aria-label={label} />;
}
